import {ComponentPropsWithoutRef, FC} from 'react'
import classNames from 'classnames'
import styles from './Container.scss'

export const Container: FC<ComponentPropsWithoutRef<'div'>> = ({className, children, ...props}) => (
  <div className={classNames(styles.container, className)} {...props}>
    {children}
  </div>
)
